import React from 'react';
import {Link} from 'react-router-dom';

import classes from './CategoryTab.module.css';

const CategoryTab = (props) => {
    //console.log(props);
    const link = '/category/' + props.category.id;
    return (
        <div className={classes.CategoryTabSmall} >
                
                    <div className={classes.CategoryInnerWrapper}>
                        
                        <div className={classes.TabImg} >
                            <img src={props.category.img} alt={props.category.name}/>
                        </div>
                        <Link to={link} className={classes.CategoryLinkWrapper}>
                            <h2>{props.category.name[0]}</h2>
                        </Link>
                    </div>
                
        </div>
    )
}

export default CategoryTab;
